// Campus photo for /colleges/university-of-massachusetts-boston: CC BY 4.0, by 4300streetcar, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUMass_Boston_campus_from_west_November_2025.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-massachusetts-boston/; credited under the photo.
const photo = {
    "slug": "university-of-massachusetts-boston",
    "alt": "The UMass Boston campus on Columbia Point seen across the water from Morrissey Boulevard in Boston, Massachusetts",
    "src": "/colleges/university-of-massachusetts-boston/campus-1600.webp",
    "srcSmall": "/colleges/university-of-massachusetts-boston/campus-800.webp",
    "srcMid": "/colleges/university-of-massachusetts-boston/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-massachusetts-boston/og.jpg",
    "title": "UMass Boston campus from west November 2025",
    "author": "4300streetcar",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUMass_Boston_campus_from_west_November_2025.jpg",
    "read": "2026-10-02"
};

export default photo;
